import { render, staticRenderFns } from "./PageNavigator.vue?vue&type=template&id=54fd5961&scoped=true"
import script from "./PageNavigator.vue?vue&type=script&lang=js"
export * from "./PageNavigator.vue?vue&type=script&lang=js"
import style0 from "./PageNavigator.vue?vue&type=style&index=0&id=54fd5961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd5961",
  null
  
)

export default component.exports